import React from "react";
import { useEffect, useState } from "react";
import "./index.css";
import ToastMessages from "helper/toastMessages";
import { toast } from "react-toastify";

function CopyDataComponent(props) {
  const [copySuccess, copySuccessSet] = useState(false);

  const copyData = async () => {
    try {
      await navigator.clipboard.writeText(props.data);
      copySuccessSet(true);
      toast.success(ToastMessages.copySuccess);
    } catch (error) {
      copySuccessSet(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      copySuccessSet(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <button type="button" className="copy-button">
      <i
        className="pi pi-copy"
        style={{ marginLeft: "5px" }}
        onClick={() => {
          copyData();
        }}
      ></i>
    </button>
  );
}

export default CopyDataComponent;
